import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BrandingService } from '../../core/branding/branding.service';

/** Shown only while an admin previews a tenant's branding with `?preview=<tenantId>`. */
@Component({
	selector: 'dmp-branding-preview-banner',
	standalone: true,
	template: `
		@if (branding.preview(); as preview) {
			<div class="branding-preview-banner" role="status">
				<span>
					Previewing branding for <strong>{{ preview.tenantName || 'tenant ' + preview.tenantId }}</strong>
					— only you can see this.
				</span>
				<button type="button" class="branding-preview-banner__exit" (click)="exit()">Exit preview</button>
			</div>
		}
	`,
	styles: [
		`
			:host {
				display: contents;
			}

			.branding-preview-banner {
				display: flex;
				align-items: center;
				justify-content: center;
				gap: 12px;
				min-height: 36px;
				padding: 6px 16px;
				flex-shrink: 0;
				background: #1d4ed8;
				color: #fff;
				font-size: 13px;
				font-weight: 500;
				text-align: center;
			}

			.branding-preview-banner__exit {
				padding: 4px 12px;
				border: 1px solid rgba(255, 255, 255, 0.6);
				border-radius: 6px;
				background: transparent;
				color: inherit;
				font: inherit;
				font-weight: 600;
				cursor: pointer;
			}

			.branding-preview-banner__exit:hover {
				background: rgba(255, 255, 255, 0.12);
			}

			.branding-preview-banner__exit:focus-visible {
				outline: 2px solid #fff;
				outline-offset: 2px;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandingPreviewBannerComponent {
	readonly branding = inject(BrandingService);

	exit(): void {
		void this.branding.exitPreview();
	}
}
